module.exports = __webpack_public_path__ + "static/media/LegoShadowTheatreINTA0056_design_clean_v001.662052a4.png";